import React, { Fragment } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import store from "./store/index";
import App from './App';

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { firebaseConfig } from "./utils/constants/firebaseConfig";
import { ANALYTICS_ENABLED } from "./analytics";

const app = initializeApp(firebaseConfig);
// Events go to Firebase only on the prod realm (see src/analytics).
if (ANALYTICS_ENABLED) getAnalytics(app);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Fragment>
      <App />
    </Fragment>
  </Provider>
);
